import { Box, Button, Grid, Typography, TextField } from '@mui/material';
import { deepPurple } from '@mui/material/colors';

import { gridSpacing } from 'app/constant';
import { useState } from 'react';

const TasklistFilter = ({ fetchTaskList, setTasklist }) => {
    // Filter tasklist related
    const [filterTaskValueRangeStart, setFilterTaskValueRangeStart] = useState(0);
    const [filterTaskValueRangeEnd, setFilterTaskValueRangeEnd] = useState(0);
    const [filterIsLoading, setFilterIsLoading] = useState(false);

    const handleTasklistFilter = () => {
        setFilterIsLoading(true);
        fetchTaskList(filterTaskValueRangeStart, filterTaskValueRangeEnd).then((data) => {
            setFilterIsLoading(false);
            setTasklist(data);
        });
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '10px'
                }}
            >
                <Typography id="modal-modal-title" variant="h3" component="h2">
                    Filter Tasklist
                </Typography>
            </Box>
            <Grid item container xs={12} spacing={gridSpacing} sx={{ overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Task Value Range Start :
                        </Typography>
                        <TextField
                            type="number"
                            id="outlined-basic"
                            variant="outlined"
                            value={filterTaskValueRangeStart}
                            onChange={(e) => setFilterTaskValueRangeStart(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Task Value Range End :
                        </Typography>
                        <TextField
                            type="number"
                            id="outlined-basic"
                            variant="outlined"
                            value={filterTaskValueRangeEnd}
                            onChange={(e) => setFilterTaskValueRangeEnd(e.target.value)}
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Button
                        variant="contained"
                        sx={{
                            float: 'right',
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500]
                        }}
                        onClick={handleTasklistFilter}
                        disabled={filterIsLoading}
                    >
                        Filter
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

export default TasklistFilter;
